module.exports = __webpack_public_path__ + "img/20220905.d007e7a4.png";